<!--  -->
<template>
    <div class='content'>
        <div class="member_list">
            <div class="member_tips">
                <div class="member_green">
                    <div>{{ language['会员号'][LT] }}</div>
                    <el-input class="inputs" v-model="keyword" :placeholder="language['请输入内容'][LT]"></el-input>
                    <el-button type="info" @click="reset()">{{ language['重置'][LT] }}</el-button>
                    <el-button type="info" @click="getMemberList()">{{ language['查询'][LT] }}</el-button>
                </div>
                <el-button type="primary" @click="addMemberShow = true"> {{ language['添加会员'][LT] }}</el-button>
            </div>
            <div class="table">
                <el-table :data="tableData" border style="width: 100%" :empty-text="language['暂无数据'][LT]">
                    <el-table-column type="index" align="center" label="ID" width="180"></el-table-column>
                    <el-table-column prop="mobile" align="center" :label="language['手机号'][LT]" width="180"></el-table-column>
                    <el-table-column prop="name" align="center" :label="language['姓名'][LT]" width="180"></el-table-column>
                    <el-table-column prop="money" align="center" :label="language['余额(元)'][LT]"></el-table-column>
                    <el-table-column prop="create_time" align="center" :label="language['最后充值时间'][LT]"></el-table-column>
                    <el-table-column prop="sy_name" align="center" :label="language['收银员'][LT]"></el-table-column>
                    <el-table-column align="center" :label="language['操作'][LT]">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="userChange(scope.row,1)"> {{ language['充值'][LT] }}</el-button>
                            <el-button type="text" size="small" @click="userChange(scope.row,2)"> {{ language['编辑'][LT] }}</el-button>
                            <el-button type="text" size="small" @click="userChange(scope.row,3)"> {{ language['删除'][LT] }}</el-button>
                            <el-button type="text" size="small" @click="userChange(scope.row,4)"> {{ language['消费记录'][LT] }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination @current-change="getChange" :current-page="page" background layout="prev, pager, next"
                        :total="total"></el-pagination>
                </div>
            </div>
        </div>
        <!-- 添加会员 -->
        <el-dialog :title="language['新增会员'][LT]" :visible.sync="addMemberShow" width="50%" >
            <div class="add_member">
                <div class="input_item">
                    <span class="input_tips"> <span class="red">*</span> {{ language['会员手机号'][LT] }}</span>
                    <el-input class="input_content" maxlength="11" v-model="mobile" :placeholder="language['请输入会员手机号'][LT]"></el-input>
                </div>
                <div class="input_item">
                    <span class="input_tips"> {{ language['会员姓名'][LT] }}</span>
                    <el-input class="input_content" v-model="name" :placeholder="language['请输入会员姓名'][LT]"></el-input>
                </div>
                <!-- <div class="input_item">
                    <span class="input_tips">{{ language['充值类型'][LT] }}</span>
                    <el-select class="input_content" v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div> -->
                <div class="input_item">
                    <span class="input_tips"><span class="red">*</span> {{ language['充值金额'][LT] }}</span>
                    <el-input class="input_content" v-model="money" :placeholder="language['请输入充值金额'][LT]"></el-input>
                </div>
                <!-- <div class="input_item">
                    <span class="input_tips"> {{ language['充值余额'][LT] }}</span>
                    <el-input class="input_content" v-model="input" placeholder="请输入内容"></el-input>
                </div> -->
                <div class="btns">
                    <el-button type="info" @click="closeChange"> {{ language['取消'][LT] }}</el-button>
                    <el-button @click="addRecharge" type="primary"> {{ language['确定'][LT] }}</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 添加会员 -->

        <!-- 会员充值 -->
        <el-dialog :title="typeNum== 1 ? language['会员充值'][LT]:language['编辑'][LT]" :visible.sync="rechargeShow" width="50%" >
            <div class="add_member">
                <div class="input_item">
                    <span class="input_tips"> {{ language['会员手机号'][LT] }}</span>
                    <el-input class="input_content" v-model="memberDetails.mobile" placeholder="请输入内容"></el-input>
                </div>
                <div class="input_item">
                    <span class="input_tips"> {{ language['会员姓名'][LT] }}</span>
                    <el-input class="input_content" v-model="memberDetails.name" placeholder="请输入内容"></el-input>
                </div>
                <div class="input_item" v-if="typeNum == 2">
                    <span class="input_tips">{{ language['充值类型'][LT] }}</span>
                    <el-radio v-model="rechargeType" label="1">{{ language['增加'][LT] }}</el-radio>
                    <el-radio v-model="rechargeType" label="2">{{ language['减少'][LT] }}</el-radio>
                </div>
                <div class="input_item">
                    <span class="input_tips"><span class="red">*</span> {{ language['充值金额'][LT] }}</span>
                    <el-input class="input_content" v-model="money" placeholder="请输入充值金额" ></el-input>
                </div>
                <div class="input_item">
                    <span class="input_tips"> {{ language['现有余额'][LT] }}</span>
                    <el-input class="input_content" v-model="memberDetails.money" placeholder="请输入内容" :disabled="true"></el-input>
                </div>
                <div class="input_item">
                    <span class="input_tips"> {{ language['备注'][LT] }}</span>
                    <el-input class="input_content" type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
                </div>
                <div class="btns">
                    <el-button type="info" @click="cutPopp()"> {{ language['取消'][LT] }}</el-button>
                    <el-button type="primary" @click="topUpNum()"> {{ language['确定'][LT] }}</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 会员充值结束 -->
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import language from '../../static/i18n/zh';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            keyword: '',
            tableData: [],
            addMemberShow: false,
            rechargeShow: false,
            mobile: '', //会员手机号
            name: '', //会员名称
            money: '', //充值金额
            keyword: '', //搜索内容
            page: 1, //当前页数
            total:0,
            input:'',
            typeNum:1,//弹窗标题
            memberDetails:{},//会员信息
            textarea:'',//备注
            rechargeType:'1',//充值类型 1=增加，2=减少
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 重置
        reset(){
            this.keyword = ''
            this.getMemberList()
        },
        //充值
        topUpNum(){
            if(!this.money)return this.$message.info('请输入充值金额')
            this.$post('64d59cd9952ef', { 
                money: this.money, 
                id: this.memberDetails.id,
                type:this.rechargeType,
                remark:this.textarea
            }).then(res => {
                if (res.code == 1) {
                    this.money = ''
                    this.rechargeShow = false
                    this.$message.info(res.msg)
                    this.page = 1;
                    this.rechargeType = '1';
                    this.textarea = '';
                    this.getMemberList();
                }else{
                    this.$message.info(res.msg)
                }
            })
        },
        cutPopp(){
            this.money = '';
            this.textarea = '';
            this.rechargeType = '1';
            this.rechargeShow = false
        },
        userChange(item,type){
            console.log(item);
            this.memberDetails = item
            this.typeNum = type 

            // type 1充值 2编辑 3删除 4消费记录
            if(type == 1 || type == 2){
                this.rechargeShow = true
            }else if (type == 3) {// 删除会员
                this.$confirm('此操作将删除会员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$post('64e6fbc875578', {id: this.memberDetails.id}).then(res => {
                        if (res.code == 1) {
                            this.page = 1;
                            this.getMemberList();
                        }else{
                            this.$message.info(res.msg)
                        }
                })
                
            })
            } else if(type == 4) {
                this.$router.push({ path: `/consumptionRecords?id=${item.id}` })
            }
        },
        // 关闭弹窗
        closeChange(){
            this.addMemberShow = false;
            this.mobile = '';
            this.name = '';
            this.money = '';
        },
        // 切换分页 
        getChange(event) {
            this.page = event;
            this.tableData = [];
            this.getMemberList();
        },
        // 会员列表
        getMemberList() {
            this.$post('64d5982e9e89f', { keyword: this.keyword, page: this.page }).then(res => {
                if (res.code == 1) {
                    console.log('会员列表', res);
                    this.tableData = res.data.data
                }
            })
        },
        // 添加会员
        addRecharge() {
            if (this.mobile == '') {
                return this.$message.error('请输入会员手机号');
            }
            if (this.name == '') {
                return this.$message.error('请输入会员名称');
            }
            if (this.money == '') {
                return this.$message.error('请输入充值金额');
            }
            this.$post('64d5959d8ae46', { mobile: this.mobile, name: this.name, money: this.money }).then(res => {
                if (res.code == 1) {
                    this.page = 1;
                    this.closeChange()
                    this.getMemberList();
                }else{
                    this.$message.info(res.msg)
                }
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getMemberList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.mobileNum = this.$route.query.mobile;
        if(this.mobileNum){
            this.$post('64e80f2aa504c', { mobile: this.mobileNum }).then(res => {
                if (res.code == 1 && res.data.id) {
                    // console.log('会员详情', res);
                    this.userChange(res.data,1)
                }
            })
        }
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.content {
    background: #eee;
    /* height: 100vh; */
    padding: 20px;
    box-sizing: border-box;
}

.member_list {
    background: #fff;
    padding: 15px;

}

.member_tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.member_green {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.member_green div {
    margin-right: 10px;
    min-width: 100px;
}

.inputs {
    margin-right: 100px;
}

.table {
    margin-top: 20px;
}

.page {
    text-align: center;
    margin-top: 40px;
}

.add_member {}

.input_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
}

.red {
    font-size: 20px;
    color: red;
}

.input_content {
    width: 60%;
}

.input_tips {
    max-width: 200px;
    display: flex;
    align-items: center;
    width: 90px;
}

.btns {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/view/memberList.vue